
const maintenanceRecordStore = {
  state: {
    record: null
  },
  actions: {
    async updateMaintenanceItem (context, payload) {
      context.commit('commitMaintenanceItem', payload)
    }
  },
  mutations: {
    commitMaintenanceItem (state, payload) {
      state.record = payload
    }
  }
}

export default maintenanceRecordStore
